export default __webpack_public_path__ + "static/media/custom-benefit.ba50cc16.png";